import {useCallback} from "react"

export const useChaseSubmitNeo = () => {
    return useCallback(async () => {
        window.wpwl.executePayment('wpwl-container-card')

        await new Promise(resolve => setTimeout(resolve, 10 * 1000))
    }, [])
}